import React from 'react';
import styles from './index.module.css';

export type LearnerPageTitleProps = {
  title: string;
};

export const LearnerPageTitle = ({ title }: LearnerPageTitleProps) => {
  return <h2 className={styles.learnerPageTitle}>{title}</h2>;
};
